import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

class EventNotificationService {
    constructor() {
        this.eventNotification = new BehaviorSubject(0);
        this.event$ = this.eventNotification.asObservable();
    }
    eventTriggered(data) {
        this.eventNotification.next(data);
    }
}
EventNotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EventNotificationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EventNotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EventNotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: EventNotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

export { EventNotificationService };
